'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _reduxImmutable = require('redux-immutable');

var _reduxTunnel = require('@wh/redux-tunnel');

var _reduxGlobalSettings = require('@wh/redux-global-settings');

var _translationTokens = require('@wh/translation-tokens');

var _reduxConfigProvider = require('@wh/redux-config-provider');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line flowtype/no-weak-types

// app types
var settings = (0, _reduxImmutable.combineReducers)((0, _extends3.default)({}, _reduxGlobalSettings.reducers.settings));

var getReducers = function getReducers() {
    var appReducers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, _reduxImmutable.combineReducers)((0, _extends3.default)({}, _translationTokens.reducers, _reduxTunnel.reducers, appReducers, {
        configs: _reduxConfigProvider.configs,
        settings: settings
    }));
};

exports.default = getReducers;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/site-base-app-container/dist/main/reducers/index.js
// module id = 535
// module chunks = 0